module.exports = __webpack_public_path__ + "static/img/a8.dfaf1ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate/attestation/a8.png
// module id = Hgd5
// module chunks = 0